



























































































import { Component, Inject, Mixins, Prop } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";
import { DataModules } from "@/store/modules/data";
import {
  ContractStatusCodes as CSC,
  ContractStatusMap,
  IContract,
  IContractProduct
} from "@/models/contracts";
import { IStatus } from "@/models/statuses";
import _ from "@/boot/lodash";
import { ICProdProvider } from "@/models/providers/contractProduct";

type IManualStatusForm = {
  reason: IContractProduct["manual_status_reason"];
  status_code: IStatus["code"];
};

@Component
export default class CProdManualStatusModal extends Mixins(HasValidation) {
  // Inject

  @Inject({ from: "contractProductProvider", default: () => () => ({}) })
  public readonly $cProdProvider!: () => ICProdProvider;

  // Props

  @Prop({ required: true })
  public contractId!: IContract["id"];

  @Prop({ required: true })
  public contractProductId!: IContractProduct["id"];

  @Prop({ required: true })
  public reason!: IContractProduct["manual_status_reason"];

  @Prop({ default: null })
  public statusCode!: IContract["status"]["code"];

  @Prop({ default: false })
  public hasUnpaidInvoices!: boolean;

  // Data

  public form = {} as IManualStatusForm;
  public isProcessing = false;

  // Computed

  public get provisionConfiguration() {
    return this.$cProdProvider()?.contractProduct?.provision_configuration
      ?.name;
  }

  public get statusOptions() {
    const map = _.map(ContractStatusMap(), (m, code: CSC) => ({ ...m, code }));
    return _.filter(map, ({ code }) =>
      [CSC.ACTIVE, CSC.SUSPENDED, CSC.CANCELLED, CSC.CLOSED].includes(code)
    );
  }

  public get formIsValid() {
    if (_.isEqual(this.form, this.initForm())) return false;
    return true;
  }

  public get formIsDisabled() {
    return this.isProcessing || !this.formIsValid || this.hasErrors;
  }

  public get showUnpaidInvoicesWarning() {
    return (
      this.hasUnpaidInvoices &&
      [CSC.CANCELLED, CSC.CLOSED].includes(this.form.status_code as CSC)
    );
  }

  // Lifecycle methods

  public async created() {
    this.form = this.initForm();
  }

  // Methods

  public initForm(): IManualStatusForm {
    return {
      reason: this.reason,
      status_code: this.statusCode
    };
  }

  public async setManualStatus() {
    return this.$store.dispatch(
      `data/${DataModules.CONTRACTS_PRODUCTS}/setManualStatus`,
      {
        contractId: this.contractId,
        contractProductId: this.contractProductId,
        data: this.form
      }
    );
  }

  public async validateBeforeSubmit() {
    if (this.formIsDisabled) return;
    try {
      this.isProcessing = true;
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");
      await this.setManualStatus();
      this.$emit("success");
      this.$emit("close");
      this.$buefy.toast.open({
        message: this.$t("_.status_changed") as string
      });
    } catch (error) {
      this.isProcessing = false;
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
  }
}
